/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { orgUnitGuestSchema } from "./orgUnitGuestSchema.ts";

export const orgOrgUnitRetrievePathIdSchema = z.string();

export const orgOrgUnitRetrieveStatus200Schema = orgUnitGuestSchema;

export const orgOrgUnitRetrieveResponseSchema = orgOrgUnitRetrieveStatus200Schema;
